import * as React from 'react'
import { theme } from '../theme'
import { PromptInputProps } from '../types'

/**
 * Floating input component for entering AI image editing prompts.
 * Appears above or below the masked area based on mask position.
 *
 * @param {boolean} show - Whether to display the input
 * @param {boolean} showAbove - Whether to position above or below
 * @param {string} value - Current prompt text value
 * @param {Function} onChange - Handler for prompt text changes
 */
export const PromptInput: React.FC<PromptInputProps> = ({ show, showAbove, value, onChange }) => {
	if (!show) return null

	return (
		<div
			style={{
				position: 'absolute',
				left: '50%',
				...(showAbove ? { top: '30%' } : { bottom: '30%' }),
				transform: 'translateX(-50%)',
				zIndex: theme.zIndex.overlay,
				width: '80%',
				maxWidth: '400px',
			}}
		>
			<input
				type="text"
				placeholder="Describe the change..."
				value={value}
				onChange={(e) => onChange(e.target.value)}
				style={{
					width: '100%',
					backgroundColor: 'rgba(24, 24, 27, 0.9)',
					backdropFilter: 'blur(4px)',
					border: 'none',
					borderRadius: theme.borderRadius.sm,
					padding: theme.spacing.md,
					color: theme.colors.surface,
					fontSize: theme.typography.sizes.sm,
					fontFamily: theme.typography.fontFamily,
				}}
				autoFocus
			/>
		</div>
	)
}
